import Swiper from "swiper"
import { Navigation, Pagination } from "swiper/modules"
import fsLightbox from "fslightbox"

if (!window.customElements.get("component-image-gallery-carousel")) {
  class ImageGalleryCarousel extends HTMLElement {
    constructor() {
      super(...arguments)
    }

    connectedCallback() {
      this.defineElements()
      this.initSlider()
    }

    defineElements() {
      this.$slider = this.querySelector(".image-gallery-carousel__gallery")
      this.$pagination = this.querySelector(".image-gallery-carousel__swiper-pagination")
      this.$nextSwiper = this.querySelector(".image-gallery-carousel__control--next")
      this.$prevSwiper = this.querySelector(".image-gallery-carousel__control--prev")
    }

    initSlider() {
      this.swiper = new Swiper(this.$slider, {
        modules: [Navigation, Pagination],
        slidesPerView: "auto",
        spaceBetween: 8,
        loop: true,
        centeredSlides: false,
        initialSlide: this.getInitialSlide(),
        pagination: {
          el: this.$pagination,
          clickable: true,
        },
        breakpoints: {
          990: {
            spaceBetween: 16,
            loop: false,
            initialSlide: this.getInitialSlide(),
            navigation: {
              nextEl: this.$nextSwiper,
              prevEl: this.$prevSwiper,
            },
          },
        },
      })
    }

    getInitialSlide() {
      const total = this.$slider.getAttribute("data-total-slides")
      return total ? Math.floor(total / 2) : 0
    }
  }

  window.customElements.define("component-image-gallery-carousel", ImageGalleryCarousel)
}
